export default {
  'www.invoicesimple.com': 'app.invoicesimple.com',
  'www.staging.invoicesimple.com': 'app.staging.invoicesimple.com',
  'localhost:3002': 'localhost:3000'
};
